/* unplugin-vue-components disabled */import script from "./LiveMatchStat.vue?vue&type=script&lang=ts&setup=true"
export * from "./LiveMatchStat.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__